import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Checkbox, Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 ,FileInput} from "@blueprintjs/core";
import { Classes, Card, Elevation, Divider } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";


import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from '../svg/wait2.gif'

import { FBSAccount,Document } from '../Types'
import { SystemHeader } from '../CommonUI';
import { Pagination, PageInfo } from '../CommonUI';
import { CLHkidrMastView } from '../HkidrMast';
import i18next from 'i18next';

 
import { CLHkCrsMastView } from '../HkCrsMast'; 
import { ClClientAuthorPersonView } from './ClientAuthorPerson'; 

var showOBInfoSection:boolean = true ;


var GsbFlag: any;


var UserID: string;
var PgmCode = "FM0010" ;
var isReqAuth2:boolean = false ;

interface FBSClMastViewProps {
    gsb: AxiosInstance,
    ac: FBSAccount,
    ac0: FBSAccount,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
}

interface DocUploadFormProps {
    gsb: AxiosInstance,
    ac: FBSAccount,
    ViewMode: any,
    logKey2: any,
}

const getDocIcon = (docType: string) => {
    switch (docType.toLowerCase()) {
        case "id":
            return "id-number"
        case "signature":
            return "draw"
    }
    // contract, others
    return "document"
}

const getDocText = (docType: string) => {
    switch (docType.toLowerCase()) {
        case "id":
            return "ID"
        case "signature":
            return "Signature"
        case "contract":
            return "Contract"
        case "others":
            return "Others"
    }
    // contract, others
    return "Unknown"
}

export function FBSClMastView({ gsb, ac = {} as FBSAccount, ac0 = {} as FBSAccount, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { }, ViewMode, logKey2}: FBSClMastViewProps) {


    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)

    const [AuthUser, setAuthUser] = useState("")
    const [password, setPassword] = useState("")

    const [isHKIDRPress, setisHKIDRPress] = useState(false)
    const [isHKCRSPress, setisHKCRSPress] = useState(false)
    const [isAuthPerson, setisAuthPerson] = useState(false)


    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [isViewClientDoc, setisViewClientDoc] = useState(false)
    const [isViewClientDocPress, setisViewClientDocPress] = useState(false)   
    const [isManageClientDocPress, setisManageClientDocPress] = useState(false)
    const [showClientDoc, setshowClientDoc] = useState(true)
    const [isUploadDocPress, setisUploadDocPress] = useState(false)
    const [reloadDoc, setreloadDoc] = useState(false)
    const [docList, setDocList] = useState([] as Document[])
    const [isManageClientDoc, setisManageClientDoc] = useState(false)



    const [showOBInfoMore, setshowOBInfoMore] = useState(showOBInfoSection)


    const [OBx_USER, setOBx_USER] = useState(false)
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                setOBx_USER(GsbFlag.OBx_USER);
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
    
/*
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
*/
    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/FBSdocumentlist',
                {
                    acCode: ac.d_Acct,
                    idNo: ac.d_IDNo
                });
                setDocList(res.data.data)
            } catch (error) {
                utils.showError(error)
            }
            setreloadDoc(false)
        })()
    }, [gsb, ac.d_Acct, reloadDoc])
    
    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                        setisViewClientDoc(false)
                        setisManageClientDoc(false)
                        setshowClientDoc(false)
                        if ( res.data.data[0].d_Can_ViewClientDoc == "Y" ) {
                            setisViewClientDoc(true)
                            setshowClientDoc(true)
                        }
                        if ( res.data.data[0].d_Can_ManageClientDoc == "Y" ) {
                            setisManageClientDoc(true)
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, ac])


    const onReqViewClientDoc = () => {
        (async () => {
            try {
                const res2 = await gsb.post('/PgmAccess', {
                    userId: AuthUser,
                    password: password,
                    cIPAddr: "",
                    cReqUser: GsbFlag.UserID,
                } )
                if (res2.data.ok) {
                    setAuthUser("")
                    setPassword("")

                    const res = await gsb.post('/Master', {
                        sb_data: {
                            userId: AuthUser,
                            password: password,
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "ReqUserGroupAccessReqAuth"
                    })
                    console.log("onReqAuthDelRec res.data.data", res.data.data);
                    if ( res.data.ok && res.data.data[0].d_Can_ViewClientDoc == "Y") {
                        setshowClientDoc(true);
                        
                    } else {
                        utils.showWarn("Authorization failed")
                        setisShowAlert2(true)
                        setShowAlert2Msg("Authorization failed")
                    }

                } else {
                    utils.showError(res2.data.message)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res2.data.message)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()

    }

    const onReqManageClientDoc = () => {
        (async () => {
            try {
                const res2 = await gsb.post('/PgmAccess', {
                    userId: AuthUser,
                    password: password,
                    cIPAddr: "",
                    cReqUser: GsbFlag.UserID,
                } )
                if (res2.data.ok) {
                   setAuthUser("")
                   setPassword("")

                    const res = await gsb.post('/Master', {
                        sb_data: {
                            userId: AuthUser,
                            password: password,
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "ReqUserGroupAccessReqAuth"
                    })
                    console.log("onReqAuthDelRec res.data.data", res.data.data);
                    if ( res.data.ok && res.data.data[0].d_Can_ManageClientDoc == "Y") {
                        setisManageClientDoc(true);
                        
                    } else {
                        utils.showWarn("Authorization failed")
                        setisShowAlert2(true)
                        setShowAlert2Msg("Authorization failed")
                    }

                } else {
                    utils.showError(res2.data.message)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res2.data.message)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    if (! ("d_Acct" in ac)) return null

    return (
            <>
      
            { ViewMode === "V" && <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }

                { (GsbFlag.HKIDR_USER1) && <Button className="Col-7-1" icon="document" onClick={() => { setisHKIDRPress(true) } } >HKIDR</Button> }
                    <Dialog
                        icon={IconNames.EDIT} 
                        title = "HKIDR Master"
                        isOpen={isHKIDRPress}
                        onClose={ () => { setisHKIDRPress(false) } }
                        style={{ minWidth: '90.0%' , minHeight: '100.0%' }}
                    >
                        <DialogBody>
                        <CLHkidrMastView gsb={gsb} cSysCode="Fbsx" acCode={ac.d_Acct} ></CLHkidrMastView>
                        </DialogBody>
                    </Dialog>           
               
                { (GsbFlag.GSBXHKCRS) && <Button className="Col-8-1" icon="document" onClick={() => { setisHKCRSPress(true) } } >FATA</Button> }
                    <Dialog
                        icon={IconNames.EDIT} 
                        title = "CRS /FATCA Master"
                        isOpen={isHKCRSPress}
                        onClose={ () => { setisHKCRSPress(false) } }
                        style={{ minWidth: '90.0%' , minHeight: '100.0%' }}
                    >
                        <DialogBody>
                        <CLHkCrsMastView gsb={gsb} cSysCode="Fbsx" acCode={ac.d_Acct} ></CLHkCrsMastView>
                        </DialogBody>
                </Dialog>
 
                {  <Button className="Col-9-2" icon="document" onClick={() => { setisAuthPerson(true) } } >Authorization Person</Button> }
                    <Dialog
                        icon={IconNames.EDIT} 
                        title = "Authorization Person"
                        isOpen={isAuthPerson}
                        onClose={ () => { setisAuthPerson(false) } }
                        style={{ minWidth: '90.0%' , minHeight: '100.0%' }}
                    >
                        <DialogBody>
                        <ClClientAuthorPersonView gsb={gsb} acCode={ac.d_Acct } ></ClClientAuthorPersonView>
                        </DialogBody>
                </Dialog>

            </div> }
            { ViewMode === "L" && <div>
                Account : {ac.d_Acct}
                { (logKey2.indexOf("*A1") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Amend</div> }
                { (logKey2.indexOf("*C") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Create</div> }
                { (logKey2.indexOf("*D") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Delete</div> }
                { ! (ac0.d_AuthId.toString() == "") && <div id="DispText2">Auth : {utils.dispDate(ac0.d_AuthDate, "3")} {ac0.d_AuthTime} User {ac0.d_AuthId} </div> }
                <div className="Spacing-V-16" />
            </div> }

            <div className="Spacing-V-16" />
            <div className="Row">
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Account">
                    <InputGroup readOnly value={ac.d_Acct} />
                </FormGroup>
                <FormGroup className="Col-2-3" label="Name">
                    <InputGroup readOnly value={ac.d_Name} />
                    <InputGroup readOnly value={ac.d_Name2} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Name.toString() == "") && 
                    <div id="DispText2" > {ac0.d_Name} </div> }
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Name2.toString() == "") && 
                    <div id="DispText2" > {ac0.d_Name2} </div> }
                </FormGroup>
                <FormGroup className="Col3-5-1" label="Type">
                    <InputGroup readOnly value={utils.fbsACTypeName(ac.d_Type)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Type.toString() == "") && 
                    <div id="DispText2" > {ac0.d_Type} </div> }
                </FormGroup>
                <FormGroup className="Col-6-1" label="A/E Code">
                    <InputGroup readOnly value={ac.d_Runner} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Runner.toString() == "") && 
                    <div id="DispText2" > {ac0.d_Runner} </div> }
                </FormGroup>
                <FormGroup className="Col-7-1" label="Open Date">
                    <InputGroup readOnly value= {utils.dispDate(ac.d_OpenDate, GsbFlag.dateFormat)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_OpenDate.toString() == "") && 
                    <div id="DispText2" > {utils.dispDate(ac0.d_OpenDate, GsbFlag.dateFormat)} </div> }
                </FormGroup>
                <FormGroup className="Col-8-1" label="Status">
                    <div id="DispText">{utils.isEmptyDate(ac.d_ClsDate) ? "ACTIVE" : "CLOSED"}</div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-2-3" label="Attention">
                    <InputGroup readOnly value={ac.d_Contact} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Contact.toString() == "") && 
                    <div id="DispText2" > {ac0.d_Contact} </div> }
                </FormGroup>
                <FormGroup className="Col-7-1" label="Last Transaction Date">
                    <InputGroup readOnly value= {utils.dispDate(ac.d_LastTran, GsbFlag.dateFormat)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_LastTran.toString() == "") && 
                    <div id="DispText2" > {utils.dispDate(ac0.d_LastTran, GsbFlag.dateFormat)} </div> }
                </FormGroup>
                <FormGroup className="Col-8-1" label="Close Date">
                    <InputGroup readOnly value= {utils.dispDate(ac.d_ClsDate, GsbFlag.dateFormat)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_ClsDate.toString() == "") && 
                    <div id="DispText2" > {utils.dispDate(ac0.d_ClsDate, GsbFlag.dateFormat)} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="Mailing Address">
                    <InputGroup readOnly value={ac.d_CAddr1} />
                    <InputGroup readOnly value={ac.d_CAddr2} />
                    <InputGroup readOnly value={ac.d_CAddr3} />
                    <InputGroup readOnly value={ac.d_CAddr4} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_CAddr1.toString() == "") && 
                    <div id="DispText2" > {ac0.d_CAddr1} </div> }
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_CAddr2.toString() == "") && 
                    <div id="DispText2" > {ac0.d_CAddr2} </div> }
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_CAddr3.toString() == "") && 
                    <div id="DispText2" > {ac0.d_CAddr3} </div> }
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_CAddr4.toString() == "") && 
                    <div id="DispText2" > {ac0.d_CAddr4} </div> }
                </FormGroup>
                <FormGroup className="Col-5-4" label="Residence Address">
                    <InputGroup readOnly value={ac.d_RAddr1} />
                    <InputGroup readOnly value={ac.d_RAddr2} />
                    <InputGroup readOnly value={ac.d_RAddr3} />
                    <InputGroup readOnly value={ac.d_RAddr4} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_RAddr1.toString() == "") && 
                    <div id="DispText2" > {ac0.d_RAddr1} </div> }
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_RAddr2.toString() == "") && 
                    <div id="DispText2" > {ac0.d_RAddr2} </div> }
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_RAddr3.toString() == "") && 
                    <div id="DispText2" > {ac0.d_RAddr3} </div> }
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_RAddr4.toString() == "") && 
                    <div id="DispText2" > {ac0.d_RAddr4} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Phone">
                    <InputGroup readOnly value={ac.d_HPhone} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_HPhone.toString() == "") && 
                    <div id="DispText2" > {ac0.d_HPhone} </div> }
                </FormGroup>
                <FormGroup className="Col-3-2" label="Office">
                    <InputGroup readOnly value={ac.d_OPhone} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_OPhone.toString() == "") && 
                    <div id="DispText2" > {ac0.d_OPhone} </div> }
                </FormGroup>
                <FormGroup className="Col-5-2" label="Fax">
                    <InputGroup readOnly value={ac.d_Fax} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Fax.toString() == "") && 
                    <div id="DispText2" > {ac0.d_Fax} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="Email">
                    <InputGroup readOnly value={ac.d_Email} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Email.toString() == "") && 
                    <div id="DispText2" > {ac0.d_Email} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="ID/BR #">
                    <InputGroup readOnly value={ac.d_IDNo} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_IDNo.toString() == "") && 
                    <div id="DispText2" > {ac0.d_IDNo} </div> }
                </FormGroup>
                <FormGroup className="Col-3-1" label="Region">
                    <InputGroup readOnly value={ac.d_Region} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Region.toString() == "") && 
                    <div id="DispText2" > {ac0.d_Region} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Bank">
                    <InputGroup readOnly value={ac.d_Bank} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Bank.toString() == "") && 
                    <div id="DispText2" > {ac0.d_Bank} </div> }
                </FormGroup>
                <FormGroup className="Col-3-2" label="Bank Account #">
                    <InputGroup readOnly value={ac.d_BankAcct} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_BankAcct.toString() == "") && 
                    <div id="DispText2" > {ac0.d_BankAcct} </div> }
                </FormGroup>
            </div>

            <div className="Spacing-V-16" />
            <H5>Trading & Risk Control</H5>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Default Currency">
                    <InputGroup readOnly value={ac.d_Curcy} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Curcy.toString() == "") && 
                    <div id="DispText2" > {ac0.d_Curcy} </div> }
                </FormGroup>
                <FormGroup className="Col-2-1" label="Commission Class">
                    <InputGroup readOnly value={ac.d_CommCode} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_CommCode.toString() == "") && 
                    <div id="DispText2" > {ac0.d_CommCode} </div> }
                </FormGroup>
                <FormGroup className="Col-3-1" label="Counter Party">
                    <InputGroup readOnly value={ac.d_CParty} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_CParty.toString() == "") && 
                    <div id="DispText2" > {ac0.d_CParty} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-2" disabled inline selectedValue={ac.d_Net ? "Y" : "N"} label="Net Position (for Omnibus A/C only)" onChange={()=>{}}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Net.toString() == "") && 
                    <div id="DispText2" > {ac0.d_Net ? "Y" : "N"} </div> }
                </RadioGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-2" disabled inline selectedValue={ac.d_BankGran ? "Y" : "N"} label="Bank Guarantee Amount" onChange={()=>{}}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_BankGran.toString() == "") && 
                    <div id="DispText2" > {ac0.d_BankGran ? "Y" : "N"} </div> }
                </RadioGroup>
                <FormGroup className="Col-3-1" label="Exposure Limit (Net)">
                    <InputGroup readOnly type='number' value={utils.numToString(ac.d_NetPos)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_NetPos.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(ac0.d_NetPos)} </div> }
                </FormGroup>
                <FormGroup className="Col-4-1" label="(Day-Trade)">
                    <InputGroup readOnly type='number' value={utils.numToString(ac.d_ComPos)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_ComPos.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(ac0.d_ComPos)} </div> }
                </FormGroup>
            </div>
 
            <div className="Spacing-V-16" />
            <div className="Row">
                <RadioGroup className="Col-1-2" disabled inline selectedValue={ac.d_Professional_Investor ? "Y" : "N"} label="Professional Investor" onChange={()=>{}}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Professional_Investor.toString() == "") && 
                    <div id="DispText2" > {ac0.d_Professional_Investor ? "Y" : "N"} </div> }
                </RadioGroup>
                 <RadioGroup className="Col-3-2" disabled inline selectedValue={ac.d_RiskLevel || "L"} label="Risk Level" onChange={()=>{}}>
                    <Radio label="High" value="H" />
                    <Radio label="Medium" value="M" />
                    <Radio label="Low" value="L" />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_RiskLevel.toString() == "") && 
                    <div id="DispText2" > {ac0.d_RiskLevel} </div> }
                </RadioGroup>     
                <RadioGroup className="Col-5-2" disabled  inline selectedValue={ac.d_StaffRelated? "Y" : "N"} label="Staff Related" onChange={()=>{}}>
                    <Radio label="Yes" value="Y" />
                    <Radio  label="No" value="N" />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_StaffRelated.toString() == "") && 
                    <div id="DispText2" > {ac0.d_StaffRelated ? "Y" : "N"} </div> }
                    <InputGroup  readOnly value={ac.d_StaffRelatedRemark} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_StaffRelatedRemark.toString() == "") && 
                    <div id="DispText2" > {ac0.d_StaffRelatedRemark} </div> }
                </RadioGroup>           

                <RadioGroup className="Col-7-2" disabled inline selectedValue={ac.d_DiscretionIndicator? "Y" : "N"} label="Discretion Indicator" onChange={()=>{}}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />        
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_DiscretionIndicator.toString() == "") && 
                    <div id="DispText2" > {ac0.d_DiscretionIndicator ? "Y" : "N"} </div> }
                </RadioGroup>

            </div>            
            <div className="Row">
                <FormGroup className="Col-1-4" label="Disclaimer">
                    <InputGroup readOnly value={ac.d_Market} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Market.toString() == "") && 
                    <div id="DispText2" > {ac0.d_Market} </div> }
                </FormGroup>
            </div>



            <div className="Spacing-V-16" />
            <H5>Confirmation</H5>
            <div className="Row">
                {/* <RadioGroup className="Col-1-2" disabled inline selectedValue={ac.d_Lang || "E"} label="Language" onChange={()=>{}}>
                    <Radio label="English" value="E" />
                    <Radio label="Chinese" value="C" />
                </RadioGroup> */}
                <RadioGroup className="Col-1-2" disabled inline selectedValue={ac.d_Confirm || "N"} label="Issue Confirmation" onChange={()=>{}}>
                    <Radio label="All" value="A" />
                    <Radio label="Deal Only" value="Y" />
                    <Radio label="No" value="N" />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Confirm.toString() == "") && 
                    <div id="DispText2" > {ac0.d_Confirm} </div> }
                </RadioGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-2" disabled inline selectedValue={ac.d_SkipHCopy || "N"} label="Skip Hard Copy Statement" onChange={()=>{}}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_SkipHCopy.toString() == "") && 
                    <div id="DispText2" > {ac0.d_SkipHCopy} </div> }
                </RadioGroup>
                <RadioGroup className="Col-3-2" disabled inline selectedValue={ac.d_SEmailD || "N"} label="Email Daily Statement" onChange={()=>{}}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_SEmailD.toString() == "") && 
                    <div id="DispText2" > {ac0.d_SEmailD} </div> }
                </RadioGroup>
                <RadioGroup className="Col-5-2" disabled inline selectedValue={ac.d_SEmailM || "N"} label="Email Monthly Statement" onChange={()=>{}}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_SEmailM.toString() == "") && 
                    <div id="DispText2" > {ac0.d_SEmailM} </div> }
                </RadioGroup>
            </div>

            <div className="Spacing-V-16" />
            <H5>Others</H5>
            <div className="Row">
                <FormGroup className="Col-1-1" label="GL Bank A/C ">
                    <InputGroup readOnly value={ac.d_GLAccNo} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_GLAccNo.toString() == "") && 
                    <div id="DispText2" > {ac0.d_GLAccNo} </div> }
                </FormGroup>
            </div>

            {( GsbFlag.OBx_USER && showOBInfoMore ) && <div className="Spacing-V-16" /> }
            {( GsbFlag.OBx_USER && showOBInfoMore ) && <div className="Spacing-V-16" /> }
            {( GsbFlag.OBx_USER ) && ! showOBInfoMore && <div id="DispText" style={{justifyContent: 'flex-end'}} onClick={() => { setshowOBInfoMore(! showOBInfoMore) ; showOBInfoSection = ! showOBInfoSection }} >+ For Stock Option Section</div> }
            {( GsbFlag.OBx_USER ) && showOBInfoMore && <div id="DispText" style={{justifyContent: 'flex-end'}} onClick={() => { setshowOBInfoMore(! showOBInfoMore) ; showOBInfoSection = ! showOBInfoSection }} >- For Stock Option Section</div> }
            {( GsbFlag.OBx_USER && showOBInfoMore ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} > <div>
                <div className="Row">
                    <FormGroup className="Col-1-2" label="A/C Group (eg. A1,A2,P1,P2)" labelFor="inputAC_Group">
                        <InputGroup readOnly value={ac.d_AC_Group} />
                        { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_AC_Group.toString() == "") && 
                        <div id="DispText2" > {ac0.d_AC_Group} </div> }
                    </FormGroup>
                    <FormGroup className="Col-3-2" label="Trade Limit" labelFor="inputTradeLimit">
                        <InputGroup readOnly value={utils.formatNumber2(ac.d_Trade_Limit)} />
                        { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_Trade_Limit.toString() == "") && 
                            <div id="DispText2" > {utils.formatNumber2(ac0.d_Trade_Limit)} </div> }
                    </FormGroup>
                    <FormGroup className="Col-5-1" label="RA Margin Factor" labelFor="inputRA_MarginFactor">
                        <InputGroup readOnly value={utils.formatNumber2(ac.d_RA_MarginFactor)} />
                        { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_RA_MarginFactor.toString() == "") && 
                            <div id="DispText2" > {utils.formatNumber2(ac0.d_RA_MarginFactor)} </div> }
                    </FormGroup>
                    <FormGroup className="Col-6-1" label="SM Margin Ratio" labelFor="inputSM_MarginFatio">
                        <InputGroup readOnly value={utils.formatNumber2(ac.d_SM_MarginFatio)} />
                        { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_SM_MarginFatio.toString() == "") && 
                            <div id="DispText2" > {utils.formatNumber2(ac0.d_SM_MarginFatio)} </div> }
                    </FormGroup>
                    </div>
            </div> </Card> }


            <div className="Spacing-V-16"/>
            <div className="Row">
                <FormGroup className="Col-1-6" label="Footnote">
                    <TextArea readOnly fill rows={4} value={ac.d_footnote} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (ac0.d_footnote.toString() == "") && 
                    <div id="DispText2" > {ac0.d_footnote} </div> }
                </FormGroup>
            </div>

            { ViewMode === "V" && <div>
                { isViewClientDoc && ! showClientDoc && <div id="DispText" style={{justifyContent: 'flex-end',}} onClick={() => { setshowClientDoc(! showClientDoc) }} >Show Documents</div> }
                { ! isViewClientDoc && ! showClientDoc && <div id="DispText" style={{justifyContent: 'flex-end'}} onClick={() => { setisViewClientDocPress(true) }} >Show Documents</div> }
                <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="OK"
                        canEscapeKeyCancel={true}
                        icon="warning-sign"
                        intent={Intent.WARNING}
                        isOpen={isViewClientDocPress}
                        onCancel={ () => setisViewClientDocPress(false) }
                        onConfirm={ () => { onReqViewClientDoc(); setisViewClientDocPress(false) } }
                    >
                        <div>
                            <div>Authorization Required to View Document</div>
                            <div>Please Input User & Password</div>
                        </div>
                        <div className="Spacing-V-16"></div>
                        <FormGroup label="User" labelFor="inputAuthUser">
                            <InputGroup id="inputAuthUser" autoFocus value={AuthUser} onChange={utils.handleStringChange(s => setAuthUser(s))} />
                        </FormGroup>
                        <FormGroup label="Password" labelFor="inputPassword">
                            <InputGroup id="input2Password" type="password" value={password} onChange={utils.handleStringChange(s => setPassword(s))} />
                        </FormGroup>
                    </Alert>

                { showClientDoc && <div id="DispText" style={{justifyContent: 'flex-end'}} onClick={() => { setshowClientDoc(! showClientDoc) }} >- Documents</div> }
                {/* showClientDoc && <p className="No-Print">Documents</p> */}
                {showClientDoc && <div className="Row No-Print">
                    {docList.map((doc, i) =>
                        <AnchorButton key={i} icon={getDocIcon(doc.docType)} target="_blank" href={`${baseUrl}/FBSdocumentdownload?doctype=${doc.docType}&filename=${encodeURIComponent(doc.fileName)}&acCode=${ac.d_Acct}&inline`}>{getDocText(doc.docType)}</AnchorButton>
                    )}

                    { ! isManageClientDoc && <div id="DispText" style={{justifyContent: 'flex-end'}} onClick={() => { setisManageClientDocPress(true) }} >Show Manage Document</div> }
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="OK"
                        canEscapeKeyCancel={true}
                        icon="warning-sign"
                        intent={Intent.WARNING}
                        isOpen={isManageClientDocPress}
                        onCancel={ () => setisManageClientDocPress(false) }
                        onConfirm={ () => { onReqManageClientDoc(); setisManageClientDocPress(false) } }
                    >
                        <div>
                            <div>Authorization Required to Manage Document</div>
                            <div>Please Input User & Password</div>
                        </div>
                        <div className="Spacing-V-16"></div>
                        <FormGroup label="User" labelFor="inputAuthUser">
                            <InputGroup id="inputAuthUser" autoFocus value={AuthUser} onChange={utils.handleStringChange(s => setAuthUser(s))} />
                        </FormGroup>
                        <FormGroup label="Password" labelFor="inputPassword">
                            <InputGroup id="input2Password" type="password" value={password} onChange={utils.handleStringChange(s => setPassword(s))} />
                        </FormGroup>
                    </Alert>

                    { isManageClientDoc &&<Button icon={IconNames.UPLOAD} onClick={() => { setisUploadDocPress(true) } } >Manage Document</Button> }
                        <Dialog
                            icon={IconNames.UPLOAD} 
                            title = "Manage Document"
                            isOpen={isUploadDocPress}
                            onClose={ () => { setisUploadDocPress(false) ; setreloadDoc(true) } }
                            style={{ minWidth: '80.0%' }}
                        >
                            <DialogBody>
                            <DocUploadForm gsb={gsb} ac={ac} ViewMode={ViewMode} logKey2={logKey2.trim()} ></DocUploadForm> 
                            </DialogBody>
                        </Dialog>
                </div> }
            </div> }                
            <div className="Spacing-V-16"></div>
                <Alert
                    confirmButtonText="OK"
                    icon="tick-circle"
                    intent={Intent.SUCCESS}
                    isOpen={isShowAlert1}
                    onCancel={ () => setisShowAlert1(false) }
                    onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                >
                    <p>
                        {ShowAlert1Msg}
                    </p>
                </Alert>
                <Alert
                    confirmButtonText="OK"
                    icon="cross"
                    intent={Intent.WARNING}
                    isOpen={isShowAlert2}
                    onCancel={ () => setisShowAlert2(false) }
                    onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                >
                    <p>
                        {ShowAlert2Msg}
                    </p>
                </Alert>

        </>
    )
}




interface DocUploadFormProps {
    gsb: AxiosInstance,
    ac: FBSAccount,
    ViewMode: any,
    logKey2: any,
}


function DocUploadForm({ gsb, ac = {} as FBSAccount, ViewMode, logKey2 }: DocUploadFormProps) {

    const { t, i18n } = useTranslation();
    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />

    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [docList, setDocList] = useState([] as Document[])
    const [reloadDoc, setreloadDoc] = useState(false)
    const [showButton, setshowButton] = useState(false)
    const [ShowWait, setShowWait] = useState(false)

    const [file1Label, setFile1Label] = useState("Choose file...")
    const [file2Label, setFile2Label] = useState("Choose file...")
    const [file3Label, setFile3Label] = useState("Choose file...")
    const [importok, setimportok] = useState(false)
    const [nUploaded, setnUploaded] = useState(0)

    const [file1docType, setfile1docType] = useState("id")
    const [file2docType, setfile2docType] = useState("Sign")
    const [file3docType, setfile3docType] = useState("Contract")

    const [userKey, setuserKey] = useState("DEMO")
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [Enter2tab, setEnter2tab] = useState("Y")

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                setuserKey(GsbFlag.user_key)

                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setEnter2tab(GsbFlag.Enter2tab) ;

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    const refreshDocTasks = async () => {
        try {
            const res = await gsb.post('/FBSdocumentlist',
            {
                acCode: ac.d_Acct,
                idNo: ac.d_IDNo
            });
            //setDocList(res.data.data)

            let newData = [...res.data.data]

            for (let j = 0; j < newData.length; j++) {
                newData[j].d_select = "N" ;
            }
            setDocList(newData);

        } catch (error) {
            utils.showError(error)
        }
    }

    useEffect(() => {
        refreshDocTasks();
    }, [gsb, ac.d_Acct])

    const onUpload = (e: FormEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setnUploaded(0);

        if ( (file1Label == "Choose file..."  || file1Label.length == 0) && (file2Label == "Choose file..."  || file2Label.length == 0) && (file3Label == "Choose file..."  || file3Label.length == 0)) {
            //utils.showError("Please choose a file"); 
            setisShowAlert2(true)
            setShowAlert2Msg("Please choose a file")
            return
        } 
        ;
        
        (async () => {
            try {
                const res = await gsb.post('/importupload2',
                    new FormData(e.target as HTMLFormElement), {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });


                
                if ( res.data.uploaded > 0) {
                    setimportok(true)
                }
     
                setnUploaded(res.data.uploaded)
              
                //utils.showSuccess(`${res.data.uploaded} file(s) uploaded`)
                //setisShowAlert1(true)
                //setShowAlert1Msg(`${res.data.uploaded} file(s) uploaded, Please press Process button`)

                try {
                    const res = await gsb.post('/import',
                        {   sb_data: {
                            acCode: ac.d_Acct,
                            idNo: ac.d_IDNo,
                            impfile1Name: file1Label,
                            docType1: file1docType,
                            impfile2Name: file2Label,
                            docType2: file2docType,
                            impfile3Name: file3Label,
                            docType3: file3docType,
                        },
                        cPgmId: "ImportFBSClDoc",
                    }); 
                    console.log(res.data.data)
                    if (res.data.ok ){
                        setimportok(false)
                        if ( res.data.count > 0) {
                            setFile1Label("Choose file...")
                            setFile2Label("Choose file...")
                            setFile3Label("Choose file...")
                            refreshDocTasks();
                            setisShowAlert1(true)
                            setShowAlert1Msg(`${res.data.count} file(s) success Processed`)
                        }
                    } else {
                        if (! res.data.ok) {
                            if ( res.data.err_Msg.trim().length > 0 ) {
                                setisShowAlert2(true)
                                setShowAlert2Msg(res.data.err_Msg)
                            }
                            for (let j = 0; j < res.data.data.length; j++) {
                                utils.showError("error");
                            }
                            return
                        }
                    }
                } catch (error) {
                    showErrorBox(error)
                }

            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    const onImportFiles = () => {

        if ( (file1Label == "Choose file..."  || file1Label.length == 0) && (file2Label == "Choose file..."  || file2Label.length == 0) && (file3Label == "Choose file..."  || file3Label.length == 0)) {
            //utils.showError("Please choose a file"); 
            setisShowAlert2(true)
            setShowAlert2Msg("Please choose a file")
            return
        } 
        //console.log("onImportFiles file1Label", file1Label)
        ;
        if ( file1Label.length > 0 || file2Label.length > 0 || file3Label.length > 0) {
    
            (async () => {
                    try {
                        const res = await gsb.post('/import',
                            {   sb_data: {
                                acCode: ac.d_Acct,
                                idNo: ac.d_IDNo,
                                impfile1Name: file1Label,
                                docType1: file1docType,
                                impfile2Name: file2Label,
                                docType2: file2docType,
                                impfile3Name: file3Label,
                                docType3: file3docType,
                            },
                            cPgmId: "ImportClDoc",
                        }); 
                        console.log(res.data.ok)
                        if (res.data.ok ){
                            setimportok(false)
                            if ( res.data.count > 0) {
                                refreshDocTasks();
                                setisShowAlert1(true)
                                setShowAlert1Msg(`${res.data.count} file(s) success Processed`)
                            }
                        } else {
                            if (! res.data.ok) {
                                if ( res.data.err_Msg.trim().length > 0 ) {
                                    setisShowAlert2(true)
                                    setShowAlert2Msg(res.data.err_Msg)
                                }
                                for (let j = 0; j < res.data.data.length; j++) {
                                    utils.showError("error");
                                }
                                return
                            }
                        }
                    } catch (error) {
                        showErrorBox(error)
                    }
                })()
        }else {

            utils.showError("Please choose a file"); 

        }
    }

    const onSelectDoc = (fileName: string) => {
        if (fileName.length > 0 ) {
            let newData = [...docList]

            for (let j = 0; j < newData.length; j++) {
                if ( newData[j].fileName == fileName ) {
                    if ( newData[j].d_select == "Y" ) {
                        newData[j].d_select = "N"
                    } else {
                        newData[j].d_select = "Y"
                    }
                    break
                }
            }
            setDocList(newData);
            setshowButton(true)
        }
    }

    const onDeleteSelectDoc = () => {
        setShowWait(true)
        setshowButton(false)
        ;

        //console.log("onDeleteSelectDoc docList", docList);
        (async () => {
            try {
                const res = await gsb.post('/import',
                    {   sb_data: {
                        acCode: ac.d_Acct,
                        idNo: ac.d_IDNo,
                        docList: docList, 
                    },
                    cPgmId: "DeleteFBSClDoc",
                }); 

                if ( res.data.ok ) {
                    if ( res.data.count > 0) {
                        refreshDocTasks();
                        setisShowAlert1(true)
                        setShowAlert1Msg(`${res.data.count} file(s) success Deleted`)
                    }
                } else {
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.err_Msg)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
        setShowWait(false)
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }
    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/FBSdocumentlist',
                {
                    acCode: ac.d_Acct,
                    idNo: ac.d_IDNo
                });
                setDocList(res.data.data)
            } catch (error) {
                utils.showError(error)
            }
            setreloadDoc(false)
        })()
    }, [gsb, ac.d_Acct, reloadDoc])


    return (
        <>
            <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >            
                <div><H3>Manage Client Document</H3></div>
                <form className="Import" onSubmit={onUpload}>
                    <div className="Spacing-V-8"></div>
                    <div className="Row">
                        <Button disabled={! showButton} className="Col-1-3" icon="confirm" onClick={() => { onDeleteSelectDoc() } }>Delete Selected File(s)</Button> 
                    </div>
                    {ShowWait && <div>{imgWait}</div> }
                    <HTMLTable striped interactive condensed>
                        <thead>
                            <th className="TCol-DocName">Doc Name</th>
                            <th className="TCol-DocType">Doc Type</th>
                            <th className="TCol-View">View</th>
                            <th className="TCol-Select">Select</th>
                        </thead>
                        <tbody id="ma_tr">
                            {docList.map((doc, i) =>
                                <tr key={i} onDoubleClick={() => { } }>
                                    <td className="TCol-DocName" onClick={() => { } }>{doc.fileName}</td>
                                    <td className="TCol-DocType" onClick={() => { } }>{doc.docType}</td>
                                    <td className="TCol-View" onClick={() => { window.open(`${gsb.defaults.baseURL}/FBSdocumentdownload?doctype=${doc.docType}&filename=${encodeURIComponent(doc.fileName)}&acCode=${ac.d_Acct}&inline`, '_blank') } }>View</td>
                                    <td className="TCol-Select"><Checkbox disabled={false} checked={doc.d_select=="Y"} onChange={() => onSelectDoc(doc.fileName)} /></td>
                                </tr>
                            )}
                        </tbody>
                    </HTMLTable>
                    <div className="Spacing-V-8"></div>
                    <div className="Spacing-V-8"></div>
                    <H4>Upload File(s)</H4>
                    <div className="Spacing-V-8"></div>
                    <div className="Row">
                        <FormGroup className="Col-1-3" label="File1" labelFor="inputFile1">
                            <FileInput className="Col-1-3" inputProps={{ name: "file1" }} text={file1Label} onInputChange={utils.handleStringChange((s) => setFile1Label(utils.fileBase(s)))} />
                        </FormGroup>
                        <FormGroup className="Col3-4-1" label="Doc Type" labelFor="inputDocTupe">
                            <select id="inputDocTupe" value={file1docType} onChange={utils.handleStringChange(s => setfile1docType(s)) } >
                                <option value="id">ID</option>
                                <option value="Sign">Signature</option>
                                <option value="Contract">Contract</option>
                                <option value="Other">Others</option>
                            </select>
                        </FormGroup>
                    </div>    
                    <div className="Row">
                        <FormGroup className="Col-1-3" label="File2" labelFor="inputFile2">
                            <FileInput className="Col-1-3" inputProps={{ name: "file2" }} text={file2Label} onInputChange={utils.handleStringChange((s) => setFile2Label(utils.fileBase(s)))} />
                        </FormGroup>
                        <FormGroup className="Col3-4-1" label="Doc Type" labelFor="inputDocTupe">
                            <select id="inputDocTupe" value={file2docType} onChange={utils.handleStringChange(s => setfile2docType(s)) } >
                                <option value="id">ID</option>
                                <option value="Sign">Signature</option>
                                <option value="Contract">Contract</option>
                                <option value="Other">Others</option>
                            </select>
                        </FormGroup>
                    </div>    
                    <div className="Row">
                        <FormGroup className="Col-1-3" label="File3" labelFor="inputFile3">
                            <FileInput className="Col-1-3" inputProps={{ name: "file3" }} text={file3Label} onInputChange={utils.handleStringChange((s) => setFile3Label(utils.fileBase(s)))} />
                        </FormGroup>
                        <FormGroup className="Col3-4-1" label="Doc Type" labelFor="inputDocTupe">
                            <select id="inputDocTupe" value={file3docType} onChange={utils.handleStringChange(s => setfile3docType(s)) } >
                                <option value="id">ID</option>
                                <option value="Sign">Signature</option>
                                <option value="Contract">Contract</option>
                                <option value="Other">Others</option>
                            </select>
                        </FormGroup>
                    </div>    
                    <div className="Spacing-V-8"></div>
                    <div className="Row">
                        <Button className="Col-1-2" type="submit" icon={IconNames.UPLOAD}>Upload & Process</Button>               
                        {/* <Button disabled= {! importok} className="Col-2-1" icon={IconNames.UPLOAD} onClick={onImportFiles}>Process</Button> */}
                    </div>
                </form>


                <div className="Spacing-V-16" />
                <div className="Spacing-V-16" />
            </Card>
            <div className="Spacing-V-16"></div>
            <div>
                <div >Upload Steps : </div>
                <div >1. Browse a file(s)</div>
                <div >2. Press Upload & Process Button</div>
            </div>
            <div className="Spacing-V-16"></div>
            <Alert
                confirmButtonText="OK"
                icon="tick-circle"
                intent={Intent.SUCCESS}
                isOpen={isShowAlert1}
                onCancel={ () => setisShowAlert1(false) }
                onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
            >
                <p>
                    {ShowAlert1Msg}
                </p>
            </Alert>
            <Alert
                confirmButtonText="OK"
                icon="cross"
                intent={Intent.WARNING}
                isOpen={isShowAlert2}
                onCancel={ () => setisShowAlert2(false) }
                onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
            >
                <p>
                    {ShowAlert2Msg}
                </p>
            </Alert>
        </>
    )

}


interface FBSClMastEditProps {
    gsb: AxiosInstance,
    ac?: FBSAccount,
    isNew?: boolean,
    onSave?: (stk: FBSAccount) => void,
    onCancel?: () => void,
}

export function FBSClMastEdit({ gsb, ac = {} as FBSAccount, isNew = false, onSave = () => { }, onCancel = () => { } }: FBSClMastEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<FBSAccount>()
    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)

    const [Net, setNet] = useState(ac.d_Net ? "Y" : "N")
    const [BankGran, setBankGran] = useState(ac.d_BankGran ? "Y" : "N")


    const [ProFessionalInv, setProFessionalInv] = useState(ac.d_Professional_Investor ? "Y" : "N")
    const [DiscretionIndicator, setDiscretionIndicator] = useState(ac.d_DiscretionIndicator ? "Y" : "N")
    const [StaffRelated, setStaffRelated] = useState(ac.d_StaffRelated ? "Y" : "N")                

    const [RiskLevel, setRiskLevel] = useState(ac.d_RiskLevel|| "L")              




    const [Lang, setLang] = useState(ac.d_Lang || "E")
    const [Confirm, setConfirm] = useState(ac.d_Confirm || "N")
    const [SkipHCopy, setSkipHCopy] = useState(ac.d_SkipHCopy || "N")
    const [SEmailD, setSEmailD] = useState(ac.d_SEmailD || "N")
    const [SEmailM, setSEmailM] = useState(ac.d_SEmailM || "N")



    const [showOBInfoMore, setshowOBInfoMore] = useState(showOBInfoSection)
    const [LoanLimitValue, setLoanLimitValue] = useState(utils.numToString2(ac.d_Trade_Limit))


    const [OBx_USER, setOBx_USER] = useState(false)
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                setOBx_USER(GsbFlag.OBx_USER);
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClMastEdit UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])

    useEffect(() => {
        // Call reset to get the values of record ClientTranInfo 
        if ("d_Acct" in ac) {
            reset(ac)
        }
    }, [ac, reset])

 

    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected      
       //register({ name: "d_footnote" })
    }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    
    if (! isNew && ! ("d_Acct" in ac)) return null

   
    const onSubmit = (data: FBSAccount) => {
        // put value to json/field before write database dbf
        data.d_Net = (Net == "Y");
        data.d_BankGran = (BankGran == "Y");
        data.d_Lang = Lang;
        data.d_Confirm = Confirm;
        data.d_SkipHCopy = SkipHCopy;
        data.d_SEmailD = SEmailD;
        data.d_SEmailM = SEmailM;
        data.d_Professional_Investor = (ProFessionalInv == "Y") ;
        data.d_RiskLevel = RiskLevel; //H/M/L
        data.d_DiscretionIndicator = (DiscretionIndicator == "Y") ;
        data.d_StaffRelated = (StaffRelated == "Y") ;
        //data.d_StaffRelatedRemark ="" ;
      //  data.d_DiscretionIndicator = (DiscretionIndicator == "Y") ;
      
        data.d_Trade_Limit = utils.StringToNum2(LoanLimitValue)


        data.d_AuthTran = ""
        if (isReqAuth) {
            data.d_AuthTran = "Y"
        }

        (async () => {
            try {
                const res = await gsb.post('/fbs/Master', {sb_data: data, cPgmId: "CLMast", cAction: "CLMastValidate", isNew: isNew})

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }
                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth &&
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }
             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Account" labelFor="d_Acct" labelInfo="*">
                    <InputGroup disabled={!isNew} id="d_Acct" name="d_Acct" autoFocus={isNew} defaultValue={ac.d_Acct} placeholder="Account ..." inputRef={register({ required: true , maxLength: 12}) } />
                    {errors.d_Acct && errors.d_Acct.type === "required" && <span id="Err_msg">Account cannot be Blank</span>}
                    {errors.d_Acct && errors.d_Acct.type === "maxLength" && <span id="Err_msg">Max length is 12</span>}
                    {errors.d_Acct && errors.d_Acct.types && <span id="Err_msg">{errors.d_Acct.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-3" label="Name" labelFor="d_Name">
                    <InputGroup id="d_Name" name="d_Name" autoFocus={! isNew} defaultValue={ac.d_Name} placeholder="Name ..." inputRef={register({ maxLength: 40}) } />
                    {errors.d_Name && errors.d_Name.type === "maxLength" && <span id="Err_msg">Max length is 40</span>}
                    {errors.d_Name && errors.d_Name.types && <span id="Err_msg">{errors.d_Name.types.message}</span>}
                    <InputGroup id="d_Name2" name="d_Name2" defaultValue={ac.d_Name2} placeholder="Name 2 ..." inputRef={register({ maxLength: 40}) } />
                    {errors.d_Name2 && errors.d_Name2.type === "maxLength" && <span id="Err_msg">Max length is 40</span>}
                    {errors.d_Name2 && errors.d_Name2.types && <span id="Err_msg">{errors.d_Name2.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col3-5-1" label="Type" labelFor="d_Type" labelInfo="*">
                    <HTMLSelect id="d_Type" fill
                        name="d_Type"
                        elementRef={register}
                    >
                        <option value="N">Normal</option>
                        <option value="O">Omnibus</option>
                        <option value="I">Instruct</option>
                        <option value="C">Cash</option>
                        <option value="H">House</option>
                        <option value="$">Bank</option>
                        <option value="A">A/E</option>
                        <option value="B">Broker</option>
                    </HTMLSelect>
                </FormGroup>
                <FormGroup className="Col-6-1" label="A/E Code" labelFor="d_Acct">
                    <InputGroup id="d_Runner" name="d_Runner" defaultValue={ac.d_Runner} placeholder="A/E Code ..." inputRef={register({ maxLength: 12}) } />
                    {errors.d_Runner && errors.d_Runner.type === "maxLength" && <span id="Err_msg">Max length is 12</span>}
                    {errors.d_Runner && errors.d_Runner.types && <span id="Err_msg">{errors.d_Runner.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-7-1" label="Open Date" labelFor="d_OpenDate">
                    <InputGroup id="d_OpenDate" name="d_OpenDate" defaultValue="" type="date" inputRef={register} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-2-3" label="Attention" labelFor="d_Contact">
                    <InputGroup id="d_Contact" name="d_Contact" defaultValue={ac.d_Contact} placeholder="Attention ..." inputRef={register({ maxLength: 40}) } />
                    {errors.d_Contact && errors.d_Contact.type === "maxLength" && <span id="Err_msg">Max length is 40</span>}
                    {errors.d_Contact && errors.d_Contact.types && <span id="Err_msg">{errors.d_Contact.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-7-1" label="Last Transaction Date" labelFor="d_LastTran">
                    <InputGroup id="d_LastTran" name="d_LastTran" defaultValue="" type="date" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-8-1" label="Close Date" labelFor="d_ClsDate">
                    <InputGroup id="d_ClsDate" name="d_ClsDate" defaultValue="" type="date" inputRef={register} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="Mailing Address" labelFor="d_CAddr1">
                    <InputGroup id="d_CAddr1" name="d_CAddr1" defaultValue={ac.d_CAddr1} placeholder="Address ..." inputRef={register({ maxLength: 50}) } />
                    {errors.d_CAddr1 && errors.d_CAddr1.type === "maxLength" && <span id="Err_msg">Max length is 50</span>}
                    {errors.d_CAddr1 && errors.d_CAddr1.types && <span id="Err_msg">{errors.d_CAddr1.types.message}</span>}
                    <InputGroup id="d_CAddr2" name="d_CAddr2" defaultValue={ac.d_CAddr2} placeholder="Address ..." inputRef={register({ maxLength: 50}) } />
                    {errors.d_CAddr2 && errors.d_CAddr2.type === "maxLength" && <span id="Err_msg">Max length is 50</span>}
                    {errors.d_CAddr2 && errors.d_CAddr2.types && <span id="Err_msg">{errors.d_CAddr2.types.message}</span>}
                    <InputGroup id="d_CAddr3" name="d_CAddr3" defaultValue={ac.d_CAddr3} placeholder="Address ..." inputRef={register({ maxLength: 50}) } />
                    {errors.d_CAddr3 && errors.d_CAddr3.type === "maxLength" && <span id="Err_msg">Max length is 50</span>}
                    {errors.d_CAddr3 && errors.d_CAddr3.types && <span id="Err_msg">{errors.d_CAddr3.types.message}</span>}
                    <InputGroup id="d_CAddr4" name="d_CAddr4" defaultValue={ac.d_CAddr4} placeholder="Address ..." inputRef={register({ maxLength: 50}) } />
                    {errors.d_CAddr4 && errors.d_CAddr4.type === "maxLength" && <span id="Err_msg">Max length is 50</span>}
                    {errors.d_CAddr4 && errors.d_CAddr4.types && <span id="Err_msg">{errors.d_CAddr4.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-5-4" label="Residence Address" labelFor="d_RAddr1">
                    <InputGroup id="d_RAddr1" name="d_RAddr1" defaultValue={ac.d_RAddr1} placeholder="Address ..." inputRef={register({ maxLength: 50}) } />
                    {errors.d_RAddr1 && errors.d_RAddr1.type === "maxLength" && <span id="Err_msg">Max length is 50</span>}
                    {errors.d_RAddr1 && errors.d_RAddr1.types && <span id="Err_msg">{errors.d_RAddr1.types.message}</span>}
                    <InputGroup id="d_RAddr2" name="d_RAddr2" defaultValue={ac.d_RAddr2} placeholder="Address ..." inputRef={register({ maxLength: 50}) } />
                    {errors.d_RAddr2 && errors.d_RAddr2.type === "maxLength" && <span id="Err_msg">Max length is 50</span>}
                    {errors.d_RAddr2 && errors.d_RAddr2.types && <span id="Err_msg">{errors.d_RAddr2.types.message}</span>}
                    <InputGroup id="d_RAddr3" name="d_RAddr3" defaultValue={ac.d_RAddr3} placeholder="Address ..." inputRef={register({ maxLength: 50}) } />
                    {errors.d_RAddr3 && errors.d_RAddr3.type === "maxLength" && <span id="Err_msg">Max length is 50</span>}
                    {errors.d_RAddr3 && errors.d_RAddr3.types && <span id="Err_msg">{errors.d_RAddr3.types.message}</span>}
                    <InputGroup id="d_RAddr4" name="d_RAddr4" defaultValue={ac.d_RAddr4} placeholder="Address ..." inputRef={register({ maxLength: 50}) } />
                    {errors.d_RAddr4 && errors.d_RAddr4.type === "maxLength" && <span id="Err_msg">Max length is 50</span>}
                    {errors.d_RAddr4 && errors.d_RAddr4.types && <span id="Err_msg">{errors.d_RAddr4.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Phone" labelFor="d_HPhone">
                    <InputGroup id="d_HPhone" name="d_HPhone" defaultValue={ac.d_HPhone} placeholder="Phone ..." inputRef={register({ maxLength: 20}) } />
                    {errors.d_HPhone && errors.d_HPhone.type === "maxLength" && <span id="Err_msg">Max length is 20</span>}
                    {errors.d_HPhone && errors.d_HPhone.types && <span id="Err_msg">{errors.d_HPhone.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Office" labelFor="d_OPhone">
                    <InputGroup id="d_OPhone" name="d_OPhone" defaultValue={ac.d_OPhone} placeholder="Office ..." inputRef={register({ maxLength: 20}) } />
                    {errors.d_OPhone && errors.d_OPhone.type === "maxLength" && <span id="Err_msg">Max length is 20</span>}
                    {errors.d_OPhone && errors.d_OPhone.types && <span id="Err_msg">{errors.d_OPhone.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-5-2" label="Fax" labelFor="d_Fax">
                    <InputGroup id="d_Fax" name="d_Fax" defaultValue={ac.d_Fax} placeholder="Fax ..." inputRef={register({ maxLength: 20}) } />
                    {errors.d_Fax && errors.d_Fax.type === "maxLength" && <span id="Err_msg">Max length is 20</span>}
                    {errors.d_Fax && errors.d_Fax.types && <span id="Err_msg">{errors.d_Fax.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="Email" labelFor="d_Email">
                    <InputGroup id="d_Email" name="d_Email" defaultValue={ac.d_Email} placeholder="Email ..." inputRef={register({ maxLength: 100}) } />
                    {errors.d_Email && errors.d_Email.type === "maxLength" && <span id="Err_msg">Max length is 100</span>}
                    {errors.d_Email && errors.d_Email.types && <span id="Err_msg">{errors.d_Email.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="ID/BR #" labelFor="d_IDNo">
                    <InputGroup id="d_IDNo" name="d_IDNo" defaultValue={ac.d_IDNo} placeholder="ID/BR # ..." inputRef={register({ maxLength: 25}) } />
                    {errors.d_IDNo && errors.d_IDNo.type === "maxLength" && <span id="Err_msg">Max length is 25</span>}
                    {errors.d_IDNo && errors.d_IDNo.types && <span id="Err_msg">{errors.d_IDNo.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Region" labelFor="d_Region">
                    <InputGroup id="d_Region" name="d_Region" defaultValue={ac.d_Region} placeholder="Region ..." inputRef={register({ maxLength: 2}) } />
                    {errors.d_Region && errors.d_Region.type === "maxLength" && <span id="Err_msg">Max length is 2</span>}
                    {errors.d_Region && errors.d_Region.types && <span id="Err_msg">{errors.d_Region.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Bank" labelFor="d_Bank">
                    <InputGroup id="d_Bank" name="d_Bank" defaultValue={ac.d_Bank} placeholder="Bank ..." inputRef={register({ maxLength: 20}) } />
                    {errors.d_Bank && errors.d_Bank.type === "maxLength" && <span id="Err_msg">Max length is 20</span>}
                    {errors.d_Bank && errors.d_Bank.types && <span id="Err_msg">{errors.d_Bank.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Bank Account #" labelFor="d_BankAcct">
                    <InputGroup id="d_BankAcct" name="d_BankAcct" defaultValue={ac.d_BankAcct} placeholder="Bank Account # ..." inputRef={register({ maxLength: 20}) } />
                    {errors.d_BankAcct && errors.d_BankAcct.type === "maxLength" && <span id="Err_msg">Max length is 20</span>}
                    {errors.d_BankAcct && errors.d_BankAcct.types && <span id="Err_msg">{errors.d_BankAcct.types.message}</span>}
                </FormGroup>
            </div>

            <div className="Spacing-V-16" />
            <H5>Trading & Risk Control</H5>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Default Currency" labelFor="d_Curcy">
                    <InputGroup id="d_Curcy" name="d_Curcy" defaultValue={ac.d_Curcy} placeholder="Default Currency ..." inputRef={register({ required: true, maxLength: 3}) } />
                    {errors.d_Acct && errors.d_Acct.type === "required" && <span id="Err_msg">Default Currency cannot be Blank</span>}
                    {errors.d_Curcy && errors.d_Curcy.type === "maxLength" && <span id="Err_msg">Max length is 3</span>}
                    {errors.d_Curcy && errors.d_Curcy.types && <span id="Err_msg">{errors.d_Curcy.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="Commission Class" labelFor="d_CommCode">
                    <InputGroup id="d_CommCode" name="d_CommCode" defaultValue={ac.d_CommCode} placeholder="Commission Class ..." inputRef={register({ maxLength: 10}) } />
                    {errors.d_CommCode && errors.d_CommCode.type === "maxLength" && <span id="Err_msg">Max length is 10</span>}
                    {errors.d_CommCode && errors.d_CommCode.types && <span id="Err_msg">{errors.d_CommCode.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Counter Party" labelFor="d_CParty">
                    <InputGroup id="d_CParty" name="d_CParty" defaultValue={ac.d_CParty} placeholder="Counter Party ..." inputRef={register({ maxLength: 10}) } />
                    {errors.d_CParty && errors.d_CParty.type === "maxLength" && <span id="Err_msg">Max length is 10</span>}
                    {errors.d_CParty && errors.d_CParty.types && <span id="Err_msg">{errors.d_CParty.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-2" inline selectedValue={Net} label="Net Position (for Omnibus A/C only)" onChange={utils.handleStringChange(s => setNet(s))}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                </RadioGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-2" inline selectedValue={BankGran} label="Bank Guarantee Amount" onChange={utils.handleStringChange(s => setBankGran(s))}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                </RadioGroup>
                <FormGroup className="Col-3-1" label="Exposure Limit (Net)" labelFor="d_NetPos">
                    <InputGroup id="d_NetPos" name="d_NetPos" defaultValue={"0"} type="number" placeholder="Exposure Limit (Net) ..." inputRef={register({ min: 0}) } />
                    {errors.d_NetPos && errors.d_NetPos.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_NetPos && errors.d_NetPos.types && <span id="Err_msg">{errors.d_NetPos.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-4-1" label="(Day-Trade)" labelFor="d_ComPos">
                    <InputGroup id="d_ComPos" name="d_ComPos" defaultValue={"0"} type="number" placeholder="(Day-Trade) ..." inputRef={register({ min: 0}) } />
                    {errors.d_ComPos && errors.d_ComPos.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_ComPos && errors.d_ComPos.types && <span id="Err_msg">{errors.d_ComPos.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <RadioGroup className="Col-1-2" inline selectedValue={ProFessionalInv} label="Professional Investor" onChange={utils.handleStringChange(s => setProFessionalInv(s))}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                </RadioGroup>
                {errors.d_Professional_Investor && errors.d_Professional_Investor.types && <span id="Err_msg">{errors.d_Professional_Investor.types.message}</span>}        
 
                <RadioGroup className="Col-3-2" inline selectedValue={RiskLevel} label="Risk Level" onChange={utils.handleStringChange(s => setRiskLevel(s))}>
                    <Radio label="High" value="H" />
                    <Radio label="Medium" value="M" />
                    <Radio label="Low" value="L" />         
                </RadioGroup>   

 
                <RadioGroup className="Col-5-2" inline selectedValue={StaffRelated} label="Staff Related" onChange={utils.handleStringChange(s => setStaffRelated(s))}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />        
                    <InputGroup id="d_StaffRelatedRemark" name="d_StaffRelatedRemark" defaultValue={ac.d_StaffRelatedRemark} placeholder="S Remark ..." inputRef={register({ maxLength: 30}) } />
                    {errors.d_StaffRelatedRemark && errors.d_StaffRelatedRemark.type === "maxLength" && <span id="Err_msg">Max length is 30</span>}
                </RadioGroup>
     
                <RadioGroup className="Col-7-2" inline selectedValue={DiscretionIndicator} label="Discretion Indicator" onChange={utils.handleStringChange(s => setDiscretionIndicator(s))}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />        
                </RadioGroup>
            </div>


            <div className="Row">
                <FormGroup className="Col-1-4" label="Disclaimer" labelFor="d_Market">
                    <InputGroup id="d_Market" name="d_Market" defaultValue={ac.d_Market} placeholder="Disclaimer ..." inputRef={register({ maxLength: 50}) } />
                    {errors.d_Market && errors.d_Market.type === "maxLength" && <span id="Err_msg">Max length is 50</span>}
                    {errors.d_Market && errors.d_Market.types && <span id="Err_msg">{errors.d_Market.types.message}</span>}
                </FormGroup>
            </div>

            <div className="Spacing-V-16" />
            <H5>Confirmation</H5>
            <div className="Row">
                {/* <RadioGroup className="Col-1-2" inline selectedValue={Lang} label="Language" onChange={utils.handleStringChange(s => setLang(s))}>
                    <Radio label="English" value="E" />
                    <Radio label="Chinese" value="C" />
                </RadioGroup> */}
                <RadioGroup className="Col-1-2" inline selectedValue={Confirm} label="Issue Confirmation" onChange={utils.handleStringChange(s => setConfirm(s))}>
                    <Radio label="All" value="A" />
                    <Radio label="Deal Only" value="Y" />
                    <Radio label="No" value="N" />
                </RadioGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-2" inline selectedValue={SkipHCopy} label="Skip Hard Copy Statement" onChange={utils.handleStringChange(s => setSkipHCopy(s))}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                </RadioGroup>
                <RadioGroup className="Col-3-2" inline selectedValue={SEmailD} label="Email Daily Statement" onChange={utils.handleStringChange(s => setSEmailD(s))}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                </RadioGroup>
                <RadioGroup className="Col-5-2" inline selectedValue={SEmailM} label="Email Monthly Statement" onChange={utils.handleStringChange(s => setSEmailM(s))}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                </RadioGroup>
            </div>

            <div className="Spacing-V-16" />
            <H5>Others</H5>
            <div className="Row">
                <FormGroup className="Col-1-1" label="GL Bank A/C" labelFor="d_GLAccNo">
                    <InputGroup id="d_GLAccNo" name="d_GLAccNo" defaultValue={ac.d_GLAccNo} placeholder="GL Bank A/C ..." inputRef={register({ maxLength: 7}) } />
                    {errors.d_GLAccNo && errors.d_GLAccNo.type === "maxLength" && <span id="Err_msg">Max length is 7</span>}
                    {errors.d_GLAccNo && errors.d_GLAccNo.types && <span id="Err_msg">{errors.d_GLAccNo.types.message}</span>}
                </FormGroup>
            </div>

            {( GsbFlag.OBx_USER && showOBInfoMore ) && <div className="Spacing-V-16" /> }
            {( GsbFlag.OBx_USER && showOBInfoMore ) && <div className="Spacing-V-16" /> }
            {( GsbFlag.OBx_USER ) && ! showOBInfoMore && <div id="DispText" style={{justifyContent: 'flex-end'}} onClick={() => { setshowOBInfoMore(! showOBInfoMore) ; showOBInfoSection = ! showOBInfoSection }} >+ For Stock Option Section</div> }
            {( GsbFlag.OBx_USER ) && showOBInfoMore && <div id="DispText" style={{justifyContent: 'flex-end'}} onClick={() => { setshowOBInfoMore(! showOBInfoMore) ; showOBInfoSection = ! showOBInfoSection }} >- For Stock Option Section</div> }
            {( GsbFlag.OBx_USER && showOBInfoMore ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} > <div>
                <div className="Row">
                    <FormGroup className="Col-1-2" label="A/C Group (eg. A1,A2,P1,P2)" labelFor="inputAC_Group">
                        <InputGroup id="inputAC_Group" name="d_AC_Group" defaultValue="" placeholder="A/C Group ..." inputRef={register({ maxLength: 5}) } /> 
                        {errors.d_AC_Group && errors.d_AC_Group.types && <span id="Err_msg">{errors.d_AC_Group.types.message}</span>}
                        {errors.d_AC_Group && errors.d_AC_Group.type === "maxLength" && <span id="Err_msg">Max length is 5</span>}
                    </FormGroup>
                    <FormGroup className="Col-3-2" label="Trade Limit" labelFor="inputTradeLimit">
                        <InputGroup id="inputTradeLimit" defaultValue={LoanLimitValue} value={LoanLimitValue} onChange={utils.handleStringChange(n => setLoanLimitValue(n))}  />
                        {errors.d_Trade_Limit && errors.d_Trade_Limit.types && <span id="Err_msg">{errors.d_Trade_Limit.types.message}</span>}
                    </FormGroup>
                    <FormGroup className="Col-5-1" label="RA Margin Factor" labelFor="inputRA_MarginFactor">
                        <InputGroup className="inputNumberNoSpin" id="inputRA_MarginFactor" name="d_RA_MarginFactor" defaultValue="0" type="number" inputRef={register} />
                        {errors.d_RA_MarginFactor && errors.d_RA_MarginFactor.types && <span id="Err_msg">{errors.d_RA_MarginFactor.types.message}</span>}
                    </FormGroup>
                    <FormGroup className="Col-6-1" label="SM Margin Ratio" labelFor="inputSM_MarginFatio">
                        <InputGroup className="inputNumberNoSpin" id="inputSM_MarginFatio" name="d_SM_MarginFatio" defaultValue="0" type="number" inputRef={register} />
                        {errors.d_SM_MarginFatio && errors.d_SM_MarginFatio.types && <span id="Err_msg">{errors.d_SM_MarginFatio.types.message}</span>}
                    </FormGroup>
                </div>
            </div> </Card> }


            <div className="Spacing-V-16" />
            <div className="Row">
                {/* <textarea className="bp4-input bp4-fill Col-1-6" name="d_footnote" rows={5} ref={register}></textarea> */}
                <FormGroup className="Col-1-6" label="Footnote" labelFor="inputFootnote"> 
                    <textarea className="bp4-input bp4-fill" name="d_footnote" rows={4} ref={register}></textarea>
                </FormGroup>
            </div>
        </form>
    )
}

interface FBSClMastMainProps {
    gsb: AxiosInstance
}

// const toaster = Toaster.create({
//     position: Position.TOP,
// })

function FBSClMastMain({ gsb }: FBSClMastMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { acCode: defaultSearchValue = "" }: { acCode: string } = useParams()

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as FBSAccount[])

    const [searchKey, setSearchKey] = useState("acct")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentAc, setCurrentAc] = useState({} as FBSAccount)
    const [CurrentLog1, setCurrentLog1] = useState({} as FBSAccount)
    const [CurrentLog0, setCurrentLog0] = useState({} as FBSAccount)
    const [ViewMode, setViewMode] = useState("V")

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                UserID = res.data.Flag.UserID
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])

    useEffect(() => {

        if (logviewonly === "Y") {
            setViewMode("L")
        }
        //console.log("ClMastMain ViewMode: ", ViewMode)

        ;
        (async () => {
            try {
                if ( logKey.trim().length > 0 ) {
                    const res = await gsb.post('/fbs/Master', {
                        sb_data: {
                            d_logKey: logKey,
                        }, 
                        cPgmId: "CLMast", 
                        cAction: "ViewLogRec"
                    })
                    //console.log("FBSClMastMain ViewLogRec res.data.data", res.data.data)

                    if (res.data.ok) {
                        setCurrentLog0(res.data.data[0])
                        setCurrentLog1(res.data.data[1])
                    } else {
                        utils.showWarn(res.data.data)
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, logKey])


    const PrevRecProcess = async (ac: FBSAccount) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "PrevRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Acct === res.data.data.d_Acct) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (ac: FBSAccount) => {
        try {
            ac.d_AuthTran = ""
            if (isReqAuth2) {
                ac.d_AuthTran = "Y"
            }
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/fbs/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "DelRec"})
            if (isReqAuth2) {
                utils.showSuccess("Account No. " + ac.d_Acct + " record deleting, waiting for authorization")
            } else {
                utils.showSuccess("Account No. " + ac.d_Acct + " record deleted")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_Acct === res.data.data.d_Acct) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                setisShowAlert1(true)
                setShowAlert1Msg("Account No. " + ac.d_Acct + " record deleting, waiting for authorization")
            }
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (ac: FBSAccount) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Acct === res.data.data.d_Acct) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (ac: FBSAccount) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "AddRec"})
            if (isReqAuth2) {
                utils.showSuccess("Account No. " + ac.d_Acct + " record adding, waiting for authorization")
            } else {
                utils.showSuccess("Account No. " + ac.d_Acct + " record added")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_Acct === res.data.data.d_Acct) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                setisShowAlert1(true)
                setShowAlert1Msg("Account No. " + ac.d_Acct + " record adding, waiting for authorization")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (ac: FBSAccount) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ac, cPgmId: "CLMast", cAction: "UpdateRec"})
            if (isReqAuth2) {
                utils.showSuccess("Account No. " + ac.d_Acct + " record saving, waiting for authorization")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_Acct === res.data.data.d_Acct) {
                        setCurrentAc(data[i])
                        break
                    }
                }
                setCurrentMode("show")
                setisShowAlert1(true)
                setShowAlert1Msg("Account No. " + ac.d_Acct + " record saving, waiting for authorization")
            } else {
                utils.showSuccess("Account " + ac.d_Acct + " record saved")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_Acct === res.data.data.d_Acct) {
                        data[i] = { ...data[i], ...res.data.data }
                        //console.log("editOnSave data", i, data)
                        setData(data)
                        break
                    }
                }
                //console.log("editOnSave res.data.data", res.data.data)
                setCurrentAc(res.data.data)
                setCurrentMode("show")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        try {
            //console.log("CLMastMain onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                        }, 
                    },
                    cPgmId: "CLMast",
                    cAction: "ListRec",
                });

                //console.log("onSubmit res.data.data", res.data.data)
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        d_Acct: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "CLMast",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setCurrentAc(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("CLMastMain useEffect length > 0  called", data)
                const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: "acct",
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "CLMast",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                            }, 
                        },
                        cPgmId: "CLMast",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setCurrentAc(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    // currentMode = show
    let detail = <FBSClMastView gsb={gsb} ac={currentAc} ac0={currentAc} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ViewMode={ViewMode} logKey2={logKey2.trim()}></FBSClMastView>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <FBSClMastEdit gsb={gsb} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></FBSClMastEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <FBSClMastEdit gsb={gsb} ac={currentAc} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></FBSClMastEdit>
            break
        }

    let logKeyViewRec = <FBSClMastView gsb={gsb} ac={CurrentLog1} ac0={CurrentLog0} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ViewMode={ViewMode} logKey2={logKey2.trim()}></FBSClMastView>

    let pagination = <Pagination nPage={nPage} nTotalPage={nTotalPage} aPageNumber={aPageNumber} setnPage={(n)=>setnPage(n)}></Pagination>
    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-100">Account</th>
                <th className="TCol-60">Type</th>
                <th className="TCol-300">Name</th>
                <th className="TCol-100">Runner</th>
                <th className="TCol-120">A/C Close Date</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((ac, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td onClick={() => { setCurrentAc(ac) ; MoblieDev && setSelectedTabId("detail") }}>{ac.d_Acct}</td>
                        <td onClick={() => { setCurrentAc(ac) ; MoblieDev && setSelectedTabId("detail") }}>{ac.d_Type}</td>
                        <td onClick={() => { setCurrentAc(ac) ; MoblieDev && setSelectedTabId("detail") }}>{ac.d_Name}</td>
                        <td onClick={() => { setCurrentAc(ac) ; MoblieDev && setSelectedTabId("detail") }}>{ac.d_Runner}</td>
                        <td onClick={() => { setCurrentAc(ac) ; MoblieDev && setSelectedTabId("detail") }}>{utils.isEmptyDate(ac.d_ClsDate) ? "ACTIVE" : "CLOSED"}</td>
                        {/* <td onClick={() => { setCurrentAc(ac) }}>{ac.d_Action}</td> */}
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                { ! ( logviewonly === "Y" ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Account Information</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* define search key */}
                        <FormGroup className="Col-1-5" label="Search for" labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="acct">Account</option>
                                    <option value="name">Name</option>
                                    <option value="runner">A/E</option>
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "acct"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "acct"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        </div>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card> }
                {ViewMode === "L" && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Account Information Log View</H3>
                    <div className="Spacing-V-16" />
                    {logKeyViewRec}
                </Card> }

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default FBSClMastMain